import * as Sentry from '@sentry/nuxt'

Sentry.init({
  // Если настроено, вы можете использовать runtime config здесь
  // dsn: (useRuntimeConfig().public.sentry.dsn as string),
  dsn: (useRuntimeConfig().public.sentry.dsn as string),

  // Определение окружения
  environment: (import.meta.env.MODE as string) || 'development',

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
  tracePropagationTargets: ['localhost', 'api-gateway.nebusfinance.ru', 'docs.nebusfinance.ru', 'nebusfinance.ru', '192.168.0.13'],

  // Set sample rate for profiling - this is relative to tracesSampleRate
  profilesSampleRate: 1.0,

  // Session Replay sampling rates
  // This sets the sample rate to be 10% in production, 100% in development
  replaysSessionSampleRate: import.meta.env.PROD ? 0.1 : 1.0,

  // If the entire session is not sampled, use the below sample rate to sample
  // sessions when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Integrations for comprehensive error tracking and Session Replay
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
      maskAllInputs: false,
    }),
    // Browser tracing integration for performance monitoring
    Sentry.browserTracingIntegration(),
    // Browser profiling integration for performance profiling
    Sentry.browserProfilingIntegration(),
    Sentry.piniaIntegration(usePinia()),
  ],

  // Performance monitoring
  beforeSendTransaction(event) {
    // Filter out noisy transactions
    if (event.transaction && (
      event.transaction.includes('/_nuxt/')
      || event.transaction.includes('/favicon.ico')
      || event.transaction.includes('/__nuxt_error')
    )) {
      return null
    }
    return event
  },

  // Error filtering
  beforeSend(event) {
    // Filter out development-only errors
    if (import.meta.env.DEV) {
      // Don't send HMR related errors
      if (event.exception?.values?.[0]?.value?.includes('Loading chunk')) {
        return null
      }
    }
    return event
  },

  // Initial scope data
  initialScope: {
    tags: {
      component: 'nuxt-client',
    },
  },

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
})
